import { createFileRoute } from "@tanstack/react-router"
import { procedureInitiativeDetailViewStaticData } from "src/views/ProcedureInitiativeDetailView/constants"
import { ProcedureInitiativeDetailView } from "src/views/ProcedureInitiativeDetailView/ProcedureInitiativeDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/$procedureInitiativeId",
)({
	component: ProcedureInitiativeDetailView,
	staticData: procedureInitiativeDetailViewStaticData,
})
